import React, {useContext, useEffect, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import {Alert, Button, FormControlLabel, Stack, TextField} from "@mui/material";
import {useOutletContext} from "react-router-dom";
import Switch from "@mui/material/Switch";
import DatePicker from "../../Component/DatePicker";
import dbDate from "../../Utilities/dbDate";


function ChildrenDetails(props) {
    const description = (
        <Alert severity="warning"><strong>Zwróć uwagę na poprawność zgłaszanych danych.</strong><br/>Organizatorzy mogą
            na ich podstawie podejmować decyzję o zapisie na wydarzenie.</Alert>);


    const {children} = useOutletContext();
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [personalId, setPersonalId] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [city, setCity] = useState('');
    const [street, setStreet] = useState('');
    const [birthday, setBirthday] = useState('');
    const [specialNeeds, setSpecialNeeds] = useState('');
    const [healthCare, setHealthCare] = useState('');
    const [tetanus, setTetanus] = useState(null);
    const [diphtheria, setDiphtheria] = useState(null);
    const [otherVaccinations, setOtherVaccinations] = useState(false);
    const [oneParent, setOneParent] = useState(false);
    const [response, setResponse] = useState('');

    function _send() {
        setResponse('');
        const formData = {
            name: name,
            surname: surname,
            personal_id: personalId,
            birthday: dbDate(birthday),
            special_needs: specialNeeds,
            health_care: healthCare,
            tetanus: dbDate(tetanus),
            diphtheria: dbDate(diphtheria),
            other_vaccinations: otherVaccinations,
            one_parent: oneParent,
            postal_code: postalCode,
            city: city,
            street: street
        };
        fetch(`/api/children/${children}`, {
            method: 'PUT',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                setResponse(<Alert color={'success'} sx={{mt: 2}}>Zaktualizowano dane dziecka</Alert>);
            })
            .catch(err => {
                console.log(err);
                setResponse(<Alert color={'error'} sx={{mt: 2}}>Błąd wysyłki danych</Alert>);
            })
    }

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/children/${children}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setName(data.name);
                    setSurname(data.surname);
                    setPersonalId(data.personal_id);
                    setPostalCode(data.postal_code);
                    setCity(data.city);
                    setStreet(data.street);
                    setBirthday(data.birthday);
                    setTetanus(data.tetanus);
                    setSpecialNeeds(data.special_needs);
                    setHealthCare(data.health_care);
                    setDiphtheria(data.diphtheria);
                    setOneParent(data.one_parent);
                    setOtherVaccinations(data.other_vaccinations);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [props.data])


    return (<div>
        <Stack direction={'row'} spacing={2}>
            <Stack spacing={2} flexGrow={1}>
                <TextField
                    onChange={(e) => setName(e.target.value)}
                    label='Imię'
                    value={name}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    onChange={(e) => setSurname(e.target.value)}
                    label='Nazwisko'
                    value={surname}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    onChange={(e) => setPersonalId(e.target.value)}
                    label='Pesel'
                    value={personalId}
                    variant="outlined"
                    required
                    slotProps={{htmlInput: {minLength: 11, maxLength: 11}}}
                    fullWidth
                />

            </Stack>
            <Stack spacing={2} flexGrow={1}>

                <TextField
                    onChange={(e) => setStreet(e.target.value)}
                    label='Adres'
                    value={street}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    onChange={(e) => setPostalCode(e.target.value)}
                    label='Kod Pocztowy'
                    value={postalCode}
                    variant="outlined"

                />
                <TextField
                    onChange={(e) => setCity(e.target.value)}
                    label='Miasto'
                    value={city}
                    variant="outlined"
                    fullWidth
                />
            </Stack>
        </Stack>

        <Stack direction={'column'} spacing={2} sx={{mt: 2}}>
            <DatePicker value={birthday} onChange={setBirthday} input={{label: 'Data Urodzenia'}}/>
            <TextField
                onChange={(e) => setSpecialNeeds(e.target.value)}
                label='Informacja o specjalnych potrzebach edukacyjnych uczestnika wypoczynku, w szczególności o potrzebach wynikających z
niepełnosprawności, niedostosowania społecznego lub zagrożenia niedostosowaniem społecznym'
                value={specialNeeds}
                variant="outlined"
                fullWidth
                multiline={true}
                rows={3}
            />
            <TextField
                onChange={(e) => setHealthCare(e.target.value)}
                label='Istotne dane o stanie zdrowia uczestnika wypoczynku, rozwoju psychofizycznym i stosowanej diecie (np. na co uczestnik
jest uczulony, jak znosi jazdę samochodem, czy przyjmuje stale leki i w jakich dawkach, czy nosi aparat ortodontyczny lub
okulary)'
                value={healthCare}
                variant="outlined"
                fullWidth
                multiline={true}
                rows={3}
            />
            <DatePicker value={tetanus} onChange={setTetanus} input={{label: 'Data Szczepienia - Tężec'}}/>
            <DatePicker value={diphtheria} onChange={setDiphtheria} input={{label: 'Data Szczepienia - Błonica'}}/>
            <FormControlLabel
                control={<Switch onChange={() => setOtherVaccinations(a => !a)} checked={otherVaccinations}/>}
                label="Pozostałe szczepienia zgodnie z kalendarzem szczepień"/>
            <FormControlLabel control={<Switch onChange={() => setOneParent(a => !a)} checked={oneParent}/>}
                              label="Dziecko wychowywane samotnie przez opiekuna"/>
        </Stack>
        <Button sx={{mt: 3}} fullWidth onClick={_send} variant='contained' color={'secondary'}>Zapisz</Button>
        {response}
    </div>);
}

export default ChildrenDetails;